import { CSSProperties } from 'react';

export const NoDataLighthouse = ({ style }: { style?: CSSProperties }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="132"
      height="132"
      viewBox="0 0 132 132"
      fill="none"
      style={style}
    >
      <path
        d="M132 66C132 67.1852 131.97 68.365 131.907 69.5365C131.89 69.8693 131.868 70.2048 131.843 70.5375C131.623 73.788 131.167 76.9698 130.493 80.0718C129.902 82.7888 129.145 85.4398 128.232 88.0193C127.429 90.2935 126.506 92.51 125.463 94.6633C125.408 94.7843 125.351 94.9025 125.293 95.0208C123.002 99.693 120.175 104.055 116.892 108.026C104.786 122.667 86.482 132 66 132C45.518 132 27.214 122.669 15.1085 108.026C8.525 100.062 3.77575 90.53 1.50425 80.0718C0.517 75.537 0 70.829 0 65.9973C0 65.1695 0.0165 64.3445 0.04675 63.525V63.514L59.9115 51.4085L80.8968 47.1652V43.6948L60.7668 39.6247L59.8125 39.4323L10.967 29.557C10.967 29.557 10.9698 29.5515 10.9725 29.5487C22.7893 11.7397 43.0238 0 66 0C91.9847 0 114.461 15.015 125.227 36.8445C128.043 42.5508 130.056 48.7245 131.123 55.2145C131.7 58.7235 132 62.326 132 66Z"
        fill="#09294A"
      />
      <path
        d="M130.496 80.0746C128.224 90.5328 123.475 100.064 116.892 108.028C104.786 122.669 86.4822 132.003 66.0002 132.003C45.5182 132.003 27.2142 122.672 15.1087 108.028C8.5252 100.064 3.77596 90.5328 1.50446 80.0746H130.496Z"
        fill="#4B78AA"
      />
      <path
        d="M131.846 70.5375C131.626 73.788 131.17 76.9698 130.496 80.0718C129.905 82.7888 129.148 85.4398 128.235 88.0193C127.432 90.2935 126.508 92.51 125.466 94.6633H32.4172C32.4172 94.6633 63.7865 78.6885 72.757 73.9695C81.7302 69.2533 90.17 77.9653 99.1872 79.2055C109.863 80.674 120.26 76.021 129.784 71.5138C130.471 71.1865 131.159 70.8648 131.846 70.5375Z"
        fill="#204B7A"
      />
      <path
        d="M116.891 108.025C104.786 122.666 86.4818 132 65.9998 132C45.5178 132 27.2138 122.669 15.1083 108.025H116.891Z"
        fill="#4B78AA"
      />
      <path
        d="M128.235 88.0219C127.388 90.4199 126.404 92.7574 125.296 95.0207C123.005 99.6929 120.178 104.054 116.894 108.025H20.5949C31.9304 102.798 43.6564 98.4444 55.6382 95.0207C58.7842 94.1187 61.9467 93.2827 65.1257 92.5099C74.3217 90.2769 83.9219 88.5802 93.1949 90.4667C99.0992 91.6657 104.797 94.3029 110.817 94.2122C117.087 94.1187 122.656 91.1542 128.235 88.0192V88.0219Z"
        fill="#09294A"
      />
      <path
        d="M96.9625 101.134H75.3172L80.9465 52.4673L86.1412 46.9481L91.3332 52.4673L96.9625 101.134Z"
        fill="white"
      />
      <path
        d="M32.4775 9.13275C42.3033 3.33025 53.7625 0 66 0C74.2913 0 82.2223 1.529 89.5318 4.32025C84.1885 4.28725 78.771 5.7145 73.8128 7.821C66.5418 10.912 59.9583 15.3973 52.9953 19.1345C50.7678 20.3308 48.422 21.472 45.8975 21.6343C43.373 21.7965 40.6175 20.7598 39.4323 18.524C38.4203 16.6128 38.7118 14.212 37.697 12.3035C36.7015 10.4335 34.5923 9.38025 32.4748 9.13275H32.4775Z"
        fill="#09294A"
      />
      <path
        d="M39.597 68.7803C39.919 68.7803 40.18 68.5193 40.18 68.1973C40.18 67.8753 39.919 67.6143 39.597 67.6143C39.275 67.6143 39.014 67.8753 39.014 68.1973C39.014 68.5193 39.275 68.7803 39.597 68.7803Z"
        fill="white"
      />
      <path
        d="M47.1214 15.8758C47.2293 15.8758 47.3167 15.7883 47.3167 15.6805C47.3167 15.5727 47.2293 15.4853 47.1214 15.4853C47.0136 15.4853 46.9262 15.5727 46.9262 15.6805C46.9262 15.7883 47.0136 15.8758 47.1214 15.8758Z"
        fill="white"
      />
      <path
        d="M55.1267 58.8774C55.3409 58.8774 55.5145 58.7038 55.5145 58.4897C55.5145 58.2755 55.3409 58.1019 55.1267 58.1019C54.9126 58.1019 54.739 58.2755 54.739 58.4897C54.739 58.7038 54.9126 58.8774 55.1267 58.8774Z"
        fill="white"
      />
      <path
        d="M75.3172 35.7252C75.5313 35.7252 75.7049 35.5516 75.7049 35.3375C75.7049 35.1233 75.5313 34.9497 75.3172 34.9497C75.103 34.9497 74.9294 35.1233 74.9294 35.3375C74.9294 35.5516 75.103 35.7252 75.3172 35.7252Z"
        fill="white"
      />
      <path
        d="M101.357 71.06C101.464 71.06 101.552 70.9726 101.552 70.8647C101.552 70.7569 101.464 70.6695 101.357 70.6695C101.249 70.6695 101.161 70.7569 101.161 70.8647C101.161 70.9726 101.249 71.06 101.357 71.06Z"
        fill="white"
      />
      <path
        d="M66.7729 45.2898C66.987 45.2898 67.1606 45.1162 67.1606 44.902C67.1606 44.6879 66.987 44.5143 66.7729 44.5143C66.5587 44.5143 66.3851 44.6879 66.3851 44.902C66.3851 45.1162 66.5587 45.2898 66.7729 45.2898Z"
        fill="white"
      />
      <path
        d="M8.53893 68.585C8.75308 68.585 8.92668 68.4114 8.92668 68.1973C8.92668 67.9831 8.75308 67.8095 8.53893 67.8095C8.32479 67.8095 8.15118 67.9831 8.15118 68.1973C8.15118 68.4114 8.32479 68.585 8.53893 68.585Z"
        fill="white"
      />
      <path
        d="M108.031 57.8462C108.192 57.8462 108.322 57.7157 108.322 57.5547C108.322 57.3938 108.192 57.2632 108.031 57.2632C107.87 57.2632 107.739 57.3938 107.739 57.5547C107.739 57.7157 107.87 57.8462 108.031 57.8462Z"
        fill="white"
      />
      <path
        d="M91.6576 55.2778H80.6218L76.2411 53.3363H96.0411L91.6576 55.2778Z"
        fill="#C0C0C0"
      />
      <path
        d="M88.5665 94.2453V101.137H83.7128V94.2453C83.7128 92.906 84.799 91.8198 86.1383 91.8198C87.4775 91.8198 88.5638 92.906 88.5638 94.2453H88.5665Z"
        fill="#FFC600"
      />
      <path
        d="M126.838 40.37C125.458 40.1665 124.091 39.864 122.763 39.4818C116.652 37.73 111.092 34.496 105.355 31.757C99.6162 29.0208 93.4232 26.7273 87.0762 27.082C77.278 27.6293 69.193 34.1935 60.7697 39.6275L10.9672 29.557C16.4892 21.23 23.8537 14.2285 32.4777 9.13276C34.5952 9.38026 36.7045 10.4335 37.7 12.3035C38.7147 14.2148 38.4232 16.6128 39.4352 18.524C40.6205 20.7598 43.376 21.7965 45.9005 21.6343C48.425 21.472 50.7707 20.3308 52.9982 19.1345C59.9612 15.3973 66.5447 10.9148 73.8157 7.82101C78.774 5.71176 84.1942 4.28726 89.5347 4.32026C106.351 10.7388 119.867 23.8343 126.841 40.3673L126.838 40.37Z"
        fill="#204B7A"
      />
      <path
        d="M91.3824 40.5735H80.8994V52.5608H91.3824V40.5735Z"
        fill="#FFC600"
      />
      <path
        d="M91.3797 40.5735H80.8994L86.1409 36.6905L91.3797 40.5735Z"
        fill="white"
      />
      <path
        d="M20.2622 52.1207C20.37 52.1207 20.4575 52.0333 20.4575 51.9255C20.4575 51.8176 20.37 51.7302 20.2622 51.7302C20.1544 51.7302 20.067 51.8176 20.067 51.9255C20.067 52.0333 20.1544 52.1207 20.2622 52.1207Z"
        fill="white"
      />
      <path
        d="M94.8751 49.4918H76.2411V53.3363H96.0411V49.4918H94.8751ZM92.5458 49.8796V52.5581H91.3798V49.8796H92.5458ZM90.2166 49.8796V52.5581H89.0506V49.8796H90.2166ZM87.8873 49.8796V52.5581H86.7213V49.8796H87.8873ZM85.5581 49.8796V52.5581H84.3921V49.8796H85.5581ZM83.2288 49.8796V52.5581H82.0628V49.8796H83.2288ZM80.8996 49.8796V52.5581H79.7336V49.8796H80.8996ZM77.4043 49.8796H78.5703V52.5581H77.4043V49.8796ZM93.7091 52.5581V49.8796H94.8751V52.5581H93.7091Z"
        fill="white"
      />
      <path d="M91.3824 40.5735H80.8994V41.349H91.3824V40.5735Z" fill="white" />
      <path
        d="M82.7364 47.9572C84.1307 47.9572 85.2609 46.8269 85.2609 45.4327C85.2609 44.0385 84.1307 42.9082 82.7364 42.9082C81.3422 42.9082 80.2119 44.0385 80.2119 45.4327C80.2119 46.8269 81.3422 47.9572 82.7364 47.9572Z"
        fill="white"
      />
      <path
        d="M89.5427 47.9572C90.9369 47.9572 92.0672 46.8269 92.0672 45.4327C92.0672 44.0385 90.9369 42.9082 89.5427 42.9082C88.1484 42.9082 87.0182 44.0385 87.0182 45.4327C87.0182 46.8269 88.1484 47.9572 89.5427 47.9572Z"
        fill="white"
      />
      <path
        d="M79.6673 63.5277C80.0825 59.9472 87.0538 58.0442 89.0503 72.1572C91.0495 86.2702 92.6033 101.137 92.6033 101.137H96.962L91.6573 55.2777H80.6215L79.6673 63.5277Z"
        fill="#C0C0C0"
      />
      <path
        d="M126.838 40.3699C125.458 40.1664 124.091 39.8639 122.763 39.4817C121.432 39.0994 120.126 38.6457 118.839 38.1452L125.23 36.8527C125.799 38.0049 126.335 39.1792 126.836 40.3672L126.838 40.3699Z"
        fill="white"
      />
      <path
        d="M131.172 55.2145L112.368 51.4112L91.3827 47.168V43.6975L112.467 39.435L118.841 38.1452C120.128 38.6457 121.435 39.0995 122.766 39.4817C124.094 39.8612 125.461 40.1637 126.841 40.37C126.338 39.1792 125.802 38.0077 125.235 36.8555L125.279 36.8445C128.095 42.5507 130.108 48.7245 131.175 55.2145H131.172Z"
        fill="#D6E1EF"
      />
      <path
        d="M80.8995 43.6975V47.168L59.9143 51.4113L0.0467529 63.5168C0.321753 56.0423 1.8425 48.8868 4.40275 42.2483C6.017 41.5388 8.08775 41.2418 9.8505 41.1648H9.86975C15.499 40.9255 21.0155 42.5948 26.4193 44.1843C31.8258 45.7793 37.3945 47.3303 43.01 46.86C49.4753 46.3183 55.1953 43.219 60.7668 39.6248L80.8968 43.6948L80.8995 43.6975Z"
        fill="#D6E1EF"
      />
    </svg>
  );
};
